export default {
    label_task:{
        en:"Crop Types(new)",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Type",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Type",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Type",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_crop_id:{
        en:"Crop",
        bn:"কর্মচারী আইডি"
    },
    label_crop_name:{
        en:"Crop",
        bn:"কর্মচারী আইডি"
    },
    label_code:{
        en:"Code",
        bn:"প্রিফিক্স"
    },
}